<template>
  <div class="container" v-if="videos && videos.length > 0">
    <div class="panel panel-default">
      <van-swipe class="my-swipe colr" indicator-color="white" @change="changeClick" duration="200">
        <van-swipe-item v-for="item in videos" :key="item.index" >
          <div class="panel-body" style="padding: 0px">
            <div class="tab-content">
              <div class="panel-footer">
                <div class="row">
                  <div class="category col-xs-3 col-md-2">
                    <a class="category-top">视频</a>
                    <a class="category-bottom">Video</a>
                  </div>
                  <!-- <div class="col-xs-9 col-md-10">
                        <ul class="nav nav-tabs video-menu" role="tablist">
                            <li role="presentation" v-for="(item, index) in videos"><a href="javascript:;" aria-controls="video51" @click="changeVideo(item)" role="tab" data-toggle="tab" v-html="item.VideoName"></a></li>
                        </ul>
                    </div> -->
                </div>
              </div>
              <div role="tabpanel" class="tab-pane sdsa" id="video51" >
                <iframe
                  frameborder="0"
                  :src="item.video_urls"
                  allowfullscreen="true"
                  height="200"
                  width="100%"
                ></iframe>
                <div
                  class="col-xs-9 col-md-10"
                  :style="videos.length > 1 ? 'margin-bottom: 26px' : ''"
                >
                  <ul class="nav nav-tabs" role="tablist">
                    <li role="presentation">
                      <a
                        href="javascript:;"
                        aria-controls="video51"
                        @click="changeVideo(item)"
                        role="tab"
                        data-toggle="tab"
                        v-html="item.VideoName"
                        class="colors"
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      show: false,
      videoSrc: "",
    };
  },
  components: {},
  props: {
    videos: {
      type: Array,
      require: true,
    },
  },
  watch: {
    videos: {
      handler(val, oldVal) {
        // console.log(val)
        if (val.length > 0) this.videoSrc = val[0]["video_urls"];
      },
      deep: true,
    },
  },
  methods: {
    changeVideo(item) {
      this.videoSrc = item.video_urls;
    },
    changeClick(e){
      this.$nextTick(()=>{
          let myVideo =  $('.sdsa iframe')
          // 判断哪个索引值是多少，是0就赋值0，是1就赋值1，每次替换
            for(let i = 0;i<myVideo.length;i++){
              myVideo[i].src = ''
               if(e==0){
                 myVideo[i].src = this.videos[i].video_urls
                }else {
                  myVideo[i].src = this.videos[i].video_urls
                }
            }
      })
    }
  },
  created() {
    if (this.videos.length > 0) {
      this.videoSrc = this.videos[0]["video_urls"];
    }
    // console.log(this.videos)
  },
};
</script>
<style>
.my-swipe {
  margin: 0 4px;
}
.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 20px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
}
#video51 iframe {
  border-radius: 8px;
  margin-top: 4px;
}
.colr .van-swipe__indicators i {
  background-color: #78564c;
}
.colr .van-swipe__indicator--active {
  background-color: #78564c !important;
}
</style>
<style scoped>
.colors {
  color: #333 !important;
  font-weight: bold;
}
.nav li{
  margin-bottom: 6px;
}

</style>